<template>
  <form class="what-app-chat-box" v-on:submit.prevent='onSubmit'>
    <modal-dialog
      v-bind:value="hasFile"
      title="Отправить файл"
      v-on:input="modalClose"
      class="what-app-chat-box__modal"
      with-cross
    >
      <template>
        <div class="what-app-chat-box__modal__content">
          <input-file
            v-model="file"
            v-bind:violations="[]"
            class="what-app-chat-box__modal__file"
          />
          <textarea
            aria-label="Введите описание"
            type="text"
            v-model="captionFile"
            placeholder="Подпись к файлу"
            class="what-app-chat-box__modal__textarea"
            ref="textarea"
            rows="1"
            @focus="resize"
            @keyup="resize"
            v-on:keyup.enter="onSubmitWithFile"
          />
          <button
            type="button"
            v-bind:disabled="isSubmitDisabled"
            v-on:click="onSubmitWithFile"
            title="Отправить сообщение"
            class="what-app-chat-box__modal__button"
          >
            Отправить
          </button>
        </div>
      </template>
    </modal-dialog>
    <div class="what-app-chat-box__input">
      <div v-if="hasQuotedMessage" class="what-app-chat-box__reply">
        <div class="what-app-chat-box__reply__icon" />
        <div class="what-app-chat-box__reply__column">
          <div class="what-app-chat-box__reply__author">{{ quotedMessage.author }}</div>
          <div class="what-app-chat-box__reply__text">{{ quotedMessage.text }}</div>
        </div>
        <button
          class="what-app-chat-box__reply__exit"
          type="button"
          v-on:click="onRemoveQuotedMessage"
        />
      </div>
      <div class="what-app-chat-box__row">
        <input-file
          v-bind:violations="[]"
          class="what-app-chat-box__file"
          v-bind:view="'icon'"
          v-on:input="uploadFile"
        />
        <textarea
          aria-label="Введите сообщение"
          type="text"
          v-model="text"
          placeholder="Введите сообщение"
          class="what-app-chat-box__text"
          rows="1"
          ref="textarea"
          @focus="resize"
          @keyup="resize"
          v-on:keyup.enter="onSubmit"
        />
      </div>
    </div>
    <button
      type="submit"
      v-bind:disabled="isSubmitDisabled"
      title="Отправить сообщение"
      class="what-app-chat-box__button"
    >
      Отправить
    </button>
  </form>
</template>

<script>
import InputFile from '@/components/InputFile.vue';
import ModalDialog from '@/components/ModalDialog.vue';

/**
 * @description Название события отправки формы.
 * @type {string}
 */
const NAME_EVENT_SUBMIT = 'submit';

/**
 * @description Название события по удалению цитируемого сообщения.
 * @type {string}
 */
const NAME_EVENT_REMOVE_QUOTED_MESSAGE = 'remove-quoted-message';

/**
 * @description Компонент Whats App поля ввода сообщения чата.
 * @type {Vue}
 */
export default {
  components: {
    ModalDialog,
    InputFile,
  },
  computed: {
    isSubmitDisabled() {
      return !this.hasText && !this.hasFile;
    },
    /**
     * @description Наличие текста.
     * @returns {boolean}
     */
    hasText() {
      const text = this.text.trim();
      return text.length > 0 || !!this.file;
    },
    /**
     * @description Наличие файла.
     * @returns {boolean}
     */
    hasFile() {
      return this.file !== null;
    },
    /**
     * @description Наличие цитируемого сообщения.
     * @returns {boolean}
     */
    hasQuotedMessage() {
      return this.quotedMessage !== null;
    },
  },
  data: () => ({
    captionFile: '',
    text: '',
    file: null,
  }),
  mounted() {
    this.resize();
  },
  methods: {
    /**
     * @description Обработать событие отправки сообщения.
     * @returns {void}
     */
    onSubmit() {
      if (this.hasText || this.hasFile) {
        this.$emit(NAME_EVENT_SUBMIT, this.text, this.file);
        this.text = '';
        this.file = null;
      }
    },
    /**
     * @description Обработать событие отправки сообщения с файлом.
     * @returns {void}
     */
    onSubmitWithFile() {
      if (this.hasFile) {
        this.$emit(NAME_EVENT_SUBMIT, this.captionFile, this.file);
        this.captionFile = '';
        this.file = null;
      }
    },
    /**
     * @description Обработать событие удаления цитируемого сообщения.
     * @returns {void}
     */
    onRemoveQuotedMessage() {
      this.$emit(NAME_EVENT_REMOVE_QUOTED_MESSAGE);
    },
    resize() {
      const { textarea } = this.$refs;
      textarea.style.height = `${textarea.scrollHeight - 0}px`;
    },
    /**
     * @description Загрузка файла.
     * @param file
     */
    uploadFile(file) {
      this.file = file;
      this.captionFile = this.text;
      this.text = '';
    },
    /**
     * @description Обработка закрытия модалки загрузки файла.
     * @param show
     */
    modalClose(show) {
      if (show === false) {
        this.file = null;
        this.captionFile = '';
      }
    },
  },
  name: 'WhatsAppChatBox',
  props: {
    /**
     * @description Цитируемое сообщение.
     * @type {Object}
     */
    quotedMessage: {
      default: () => null,
      type: Object,
    },
  },
};
</script>

<style lang="scss">
@use "@/scss/buttons";
.what-app-chat-box {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 30px 43px 25px 60px;
  border-top: 1px solid #C2CFE0;
  &__modal {
    &__content {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }
    &__file {
      .file-drops__row {
        span {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 95%;
        }
      }

    }
    &__textarea {
      display: flex;
      width: 100%;
      outline: none;
      border: none;
      font-size: 16px;
      line-height: 21px;
    }
    &__button {
      @include buttons.btn-blue(100%, 50px, 16px);
      margin: 20px 0 0 0;
    }
  }
  &__input {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    border: 1px solid #C2CFE0;
    padding: 28px;
    border-radius: 4px;
    font-size: 16px;
    textarea {
      display: flex;
      width: 100%;
      outline: none;
      border: none;
      font-size: 16px;
      line-height: 21px;
    }
  }
  &__reply {
    display: grid;
    grid-template-columns: 20px 1fr 20px;
    gap: 13px;
    align-items: center;
    width: 100%;
    &__icon {
      background-image: url("@/assets/img/forward-blue.svg");
      background-size: contain;
      width: 20px;
      height: 20px;
    }
    &__column {
      display: flex;
      flex-direction: column;
      gap: 5px;
      background-color: rgba(4, 137, 224, 0.2);
      padding: 5px 20px;
      border-radius: 6px;
      border-left: 4px solid #0489E0;
      font-size: 14px;
      line-height: 16px;
      overflow: hidden;
    }
    &__author {
      color: #0489E0;
    }
    &__text {
      color: rgba(112, 118, 131, 1);
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 97%;
    }
    &__exit {
      background-image: url("@/assets/img/exit-blue.svg");
      background-size: contain;
      width: 20px;
      height: 20px;
    }
  }
  &__row {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 10px;
    width: 100%;
    textarea {
      display: flex;
      width: 100%;
      outline: none;
      border: none;
      font-size: 16px;
      line-height: 21px;
      resize: none;
    }
  }
  &__button {
    @include buttons.btn-blue(150px, 50px, 16px);
    margin: 0 0 0 auto;
    &:disabled {
      background-color: #90A0B7;
      cursor: default;
    }
  }
}
@media screen and (max-width: 480px) {
  .what-app-chat-box {
    padding: 20px 10px;
  }
}
</style>
